import React from 'react';
import styled, { keyframes } from "styled-components";
import {FadeIn} from '../../../libs/components/FadeIn';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel
  } from "react-accessible-accordion";

const StyledAccordion = styled(Accordion)`
  background-color: white;
  color: black;
  margin: 50px auto;
  // border: solid;
  // border-width: 0.25px;
  // border-color: white;
  width: 300px;
  box-shadow: 0px 0px 8px 0px #a9a9a9;
  text-align: ${(props) => props.direction ? props.direction : 'right'};
`;

const StyledAccordionItemHeading = styled(AccordionItemHeading)`
  background-color: ${(props) => props.backgroundcolor ? props.backgroundcolor : 'black'};
  padding: 10px;
  color: whitesmoke;
  border: solid .25px white;
`;

const StyledAccordionItemButton = styled(AccordionItemButton)`
  outline: none;
  &::before {
    display: inline-block;
    content: "";
    height: 5px;
    width: 5px;
    margin-right: 12px;
    border-bottom: 2px solid currentColor;
    border-right: 2px solid currentColor;
    transform: rotate(-45deg);
    float: left;
  }
  &[aria-expanded="true"]::before,
  [aria-selected="true"]::before {
    transform: rotate(45deg);
  }
`;

const fadeIn = keyframes`
  from{
    opacity:0%;
    max-height: 0px;
  }
  to{
    opacity:100%;
    max-height: 600px;
  }
`;

const StyledAccordionItemPanel = styled(AccordionItemPanel)`
  animation: ${fadeIn} 0.7s ease-in;
`;

export default function BusinessDetailes({servicesTitle,servicesDescription,openingHoursTitle,openingHours,color,direction}){

    return(
        <FadeIn> 
            <StyledAccordion allowZeroExpanded allowMultipleExpanded direction={direction}>
                {servicesDescription ?
                <AccordionItem>
                    <StyledAccordionItemHeading backgroundcolor={color}>
                    <StyledAccordionItemButton>{servicesTitle}</StyledAccordionItemButton>
                    </StyledAccordionItemHeading>
                    <StyledAccordionItemPanel>
                    <div style={{whiteSpace: "pre-wrap" , marginBottom:'20px' , padding: '5px 5px 5px 5px'}}>{servicesDescription}</div>
                    </StyledAccordionItemPanel>
                </AccordionItem>
                :null}
                {openingHours?
                <AccordionItem>
                    <StyledAccordionItemHeading backgroundcolor={color}>
                    <StyledAccordionItemButton>{openingHoursTitle}</StyledAccordionItemButton>
                    </StyledAccordionItemHeading>
                    <StyledAccordionItemPanel>
                    <div style={{whiteSpace: "pre-wrap" , marginBottom:'20px' , padding: '5px 5px 5px 5px'}}>{openingHours}</div>
                    </StyledAccordionItemPanel>
                </AccordionItem>
                :null}
            </StyledAccordion>
        </FadeIn>
    );

}